// extracted by mini-css-extract-plugin
export default {"image_icon":"iconshadow_image_icon__d-p2O"};